import { useState, useEffect, useMemo, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { reaction } from 'mobx'
import { Button, Form, Input, message } from 'antd'
import { EasyImg } from 'src/components'
import { SMSCode } from './components'
import { mainStore } from 'enasops/stores'
import { api, $api, $consts } from 'src/plugins'
import { useWindowSize, useIsLoading } from 'src/hooks'
import { uuid } from 'src/utils/tools'
import { getApiURL } from 'src/utils/axios'
import md5 from 'md5'
import 'enasops/styles/modules/login/index.less'

const verifyCodeApi = '/UT/VerificationCode/Number'

const Login = () => {
  const navigate = useNavigate()
  useEffect(() => reaction(
    () => mainStore.isLogin,
    isLogin => isLogin && navigate($consts['ROUTE/MAIN'])
  ), [])

  const [form] = Form.useForm()

  const [verifyRandomCode, setVerifyRandomCode] = useState(uuid())

  const tokenData = useRef<any>()
  const handleLogin = (values: any) => {
    if (values.UserPhone) {
      $api['common/checkVerifyCode']({
        OrgId: $consts['APP/ORG_ID'],
        Phone: values.UserPhone,
        SMSCode: values.SMSCode
      }).then(res => {
        if (res) {
          mainStore.setLoginModel(tokenData.current.loginModel)
          mainStore.setHeaders(tokenData.current.headers)
        }
      })
    } else {
      $api['app/getDataByPost'](
        {
          username: values.UserName,
          password: md5(values.Password),
          grant_type: 0,
        },
        {
          url: '/OP/Token/Gen',
          fullData: true,
          noCheckIsSuccessful: true,
          noErrorToast: true
        }
      ).then(res => {
        const { token_type: TokenType, access_token: AccessToken, refreshToken: RefreshToken, userid: UserId, phone: UserPhone } = res
        const loginModel = {
          Parameter1: values.UserName,
          Parameter2: md5(values.Password),
          Parameter4: $consts['APP/ORG_ID'],
          Parameter6: values.VerificationCode,
          Parameter7: verifyRandomCode
        }
        const headers = {
          Authorization: `${TokenType} ${AccessToken}`,
          RefreshToken,
          OrgId: $consts['APP/ORG_ID'],
          UserId,
        }
        tokenData.current = { loginModel, headers }
        if (UserPhone) {
          form.setFieldsValue({ UserPhone })
        } else {
          mainStore.setLoginModel(tokenData.current.loginModel)
          mainStore.setHeaders(tokenData.current.headers)
        }
      }).catch(err => {
        err.response.data?.error && message.error(err.response.data?.error_description || err.message)
      })
    }
  }

  const phone = Form.useWatch('UserPhone', form)

  const winSize = useWindowSize()
  const zoom = useMemo(() => {
    const z = winSize.width / 1920
    return z < 0.9 ? 0.9 : z
  }, [winSize])

  const loading = useIsLoading([api.paths['common/login']])
  return (
    <div className='login-page'>
      <div className='login-page__main' style={{ transform: `scale(${zoom})` }}>
        <div className='login-page__zone'>
          <div className='composite-login'>
            <div className='composite-login__title'>用户登录</div>
            <div className='composite-login__form'>
              <Form layout='vertical' form={form} onFinish={handleLogin}>
                <Form.Item name='UserName' label='用户名' hidden={phone} rules={[{ required: true }]}>
                  <Input placeholder='请输入用户名' />
                </Form.Item>
                <Form.Item name='Password' label='密码' hidden={phone} rules={[{ required: true }]}>
                  <Input type='password' placeholder='请输入密码' />
                </Form.Item>
                <div className='position-relative'>
                  <Form.Item name='VerificationCode' label='验证码' hidden={phone} rules={[{ required: true }]}>
                    <Input placeholder='请输入验证码' />
                  </Form.Item>
                  <img
                    key={verifyRandomCode}
                    src={`${getApiURL(verifyCodeApi)}?random=${verifyRandomCode}`}
                    alt='验证码'
                    onClick={() => setVerifyRandomCode(uuid())}
                    className='login-verify'
                  />
                </div>
                <Form.Item name='UserPhone' label='手机号' hidden={!phone} rules={[{ required: !!phone }]}>
                  <Input disabled placeholder='请输入手机号' />
                </Form.Item>
                <div className='position-relative'>
                  <Form.Item name='SMSCode' label='验证码' hidden={!phone} rules={[{ required: !!phone }]}>
                    <Input placeholder='请输入验证码' />
                  </Form.Item>
                  <SMSCode phone={phone} />
                </div>
                <Form.Item>
                  <Button
                    block
                    type='primary'
                    htmlType='submit'
                    disabled={loading}
                    loading={loading}
                  >登录</Button>
                </Form.Item>
              </Form>
            </div>
          </div>
        </div>
        <div className='login-page__footer'>
          <EasyImg src={require('enasops/assets/login/logo.png')} className='login-page__logo' />
          <div className='divider' />
          <div className='copyright'>
            <p>Copyright ©2023-2024 厦门奥普拓自控科技有限公司</p>
            <p>技术咨询 | 400-156-8399</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Login